import { render, staticRenderFns } from "./ChangeVisaThanks.vue?vue&type=template&id=82c9fbae&"
import script from "./ChangeVisaThanks.vue?vue&type=script&lang=js&"
export * from "./ChangeVisaThanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports